<div class="corte-dialog">
  <header class="corte-dialog__header">
    <div class="corte-dialog__icon" aria-hidden="true">
      <i-tabler name="calendar"></i-tabler>
    </div>
    <div>
      <h2>Plazo para confirmar la OS</h2>
      <p *ngIf="data.orderLabel">OS {{ data.orderLabel }}</p>
    </div>
  </header>

  <div class="corte-dialog__body">
    <label for="corte-date">Confirmar antes del</label>
    <div class="corte-dialog__field">
      <input
        id="corte-date"
        [matDatepicker]="picker"
        [formControl]="dateControl"
        placeholder="dd/mm/aaaa"
        autocomplete="off"
        readonly
        (click)="picker.open()"
      />
      <button
        type="button"
        class="corte-dialog__icon-btn"
        (click)="picker.open()"
        aria-label="Abrir calendario"
      >
        <mat-icon>event</mat-icon>
      </button>
      <mat-datepicker #picker panelClass="os-datepicker-panel"></mat-datepicker>
    </div>
    <p>Si esta fecha ya pasó, la OS sigue preliminar hasta que la confirmes.</p>
    <p class="corte-dialog__error" *ngIf="error">{{ error }}</p>
  </div>

  <footer class="corte-dialog__actions">
    <button type="button" class="corte-dialog__ghost" (click)="close()" [disabled]="saving">
      Cancelar
    </button>
    <button
      type="button"
      class="corte-dialog__primary"
      (click)="save()"
      [disabled]="saving || dateControl.invalid"
    >
      {{ saving ? 'Guardando…' : 'Guardar' }}
    </button>
  </footer>
</div>
